export function getNumberOfDays(startDate: Date, endDate: Date): number {
    const differenceInMs = Math.abs(endDate.getTime() - startDate.getTime());
    const differerenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    return differerenceInDays;
}
